import React, {useEffect, useMemo, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import EditGatewayManagementList from './modal/EditGatewayManagementList'
import CreateGatewayManagementList from './modal/CreateGatewayManagementList'
import {useGetAdminGatewayProviderQuery} from '../../../../services/cellcast'
import {Spinner} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {useLoadedData} from '../../../hooks/useGetLoadedData'

const GatewayManagementList = () => {
  const [gatewayPopup, setGatewayPopup] = useState(false)
  const [createGatewayPopup, setCreateGatewayPopup] = useState(false)
  const [edit, setEdit] = useState<any>({})
  const {calculate, loadedData, setLoadedData} = useLoadedData()

  const [page, setPage] = useState<any>({
    page: 1,
    size: 10,
    searchKey: '',
  })

  const {
    data: paymentGatewayList,
    isLoading,
    isFetching,
    refetch,
  } = useGetAdminGatewayProviderQuery(page)

  useEffect(() => {
    if (paymentGatewayList?.data && paymentGatewayList?.data?.total) {
      const calculatedData = calculate(page.page, page.size, paymentGatewayList?.data?.total)
      setLoadedData(calculatedData)
    }
  }, [paymentGatewayList, page.page, page.size])

  const EditGatewayManagement = useMemo(
    () => (
      <EditGatewayManagementList
        edit={edit}
        show={gatewayPopup}
        refetch={refetch}
        handleClose={() => setGatewayPopup(false)}
      />
    ),
    [gatewayPopup, edit]
  )

  const CreateGatewayManagement = useMemo(
    () => (
      <CreateGatewayManagementList
        show={createGatewayPopup}
        refetch={refetch}
        handleClose={() => setCreateGatewayPopup(false)}
      />
    ),
    [createGatewayPopup]
  )

  const handleEditPopup = (data: any) => {
    setEdit(data)
    setGatewayPopup(true)
  }

  return (
    <>
      {EditGatewayManagement}
      {CreateGatewayManagement}

      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>ALL Gateway</h3>
          </div>
          {AuthenticateUser('edit-pricerules') && (
            <div className='card-toolbar'>
              <div className='d-flex gap-3 align-items-center'>
                <button className='btn btn-primary' onClick={() => setCreateGatewayPopup(true)}>
                  Create
                </button>
              </div>
            </div>
          )}
        </div>
        <div className='card-body pt-2'>
          {isLoading || isFetching ? (
            <div className='row flex-center h-300 mb-10'>
              <Spinner />
            </div>
          ) : paymentGatewayList && paymentGatewayList?.data?.items?.length > 0 ? (
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Gateway Name</th>
                      <th>DB</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Price Per Part</th>
                      <th>DN Monthly</th>
                      <th>DN Yearly</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {paymentGatewayList?.data?.items?.map((data: any, id: number) => (
                      <tr key={id}>
                        <td>
                          <span className='badge badge-light-info'>{data?.gatewayName}</span>
                        </td>
                        <td>{data?.DB}</td>
                        <td>{data?.type}</td>
                        <td>{data?.status}</td>
                        <td>{data?.price_per_part}</td>
                        <td>{data?.DNmonthly}</td>
                        <td>{data?.DNyearly}</td>
                        {AuthenticateUser('edit-pricerules') && (
                          <td className='text-end'>
                            <span
                              onClick={() => handleEditPopup(data)}
                              className='btn btn-bg-light btn-active-color-primary btn-sm'
                            >
                              Edit
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className='abcd'>
                <select
                  onChange={(e) => {
                    setPage({...page, size: e.target.value})
                  }}
                  value={page.size}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                Show {loadedData.startLoad} - {loadedData.endLoad} of{' '}
                {paymentGatewayList?.data?.total}
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={paymentGatewayList?.data?.totalPages}
                  onPageChange={(e) => {
                    setPage({...page, page: e.selected + 1})
                  }}
                  containerClassName={'pagination'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          ) : (
            <div className='row flex-center h-300 mb-10'>
              <div className='text-center'>
                <h3>No Gateway Provider Found</h3>
                <p>Click "Create New Gateway Provider" to add a new gateway provider</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default GatewayManagementList
